import { ValidateJSModel } from 'forms/shared/types';
import { hasYesOrNo } from 'models/validate';
import { financialLienItemValidator } from './validators/item';
import { FinancialLienModel } from './types';

const financialLienValidator: ValidateJSModel<FinancialLienModel> = {
  HasLien: {
    hasValue: { validator: hasYesOrNo },
  },

  List: (value, attributes) => {
    if (attributes?.HasLien?.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: financialLienItemValidator },
      };
    }

    return {};
  },
};

export default financialLienValidator;
